import { Components, Theme } from "@mui/material";

export const MuiTableRow: Components<Omit<Theme, "MuiTableRow">>["MuiTableRow"] = {
  styleOverrides: {
    root: {
      height: 40,
    },
  },
};
